import { Header } from './header/Header';
import { InputSection } from './input/InputSection';
import { PreviewSection } from './preview/PreviewSection';
import { SelectSection } from './select/SelectSection';
import { Footer } from './footer/Footer';
import { SelectionContext, useSelectionState } from 'src/contexts/SelectionContext';
import styles from './CampaignAutomationPage.module.css';
import { ClientContextProvider } from 'src/contexts/ClientContextProvider';
import { AssetContextProvider } from 'src/contexts/AssetContextProvider';
import { CampaignCreationSection } from './create/CampaignCreationSection';
import { CampaignMetadataContextProvider } from 'src/contexts/CampaignMetadataContextProvider';
import { SmartUploadProvider, useSmartUpload } from 'src/contexts/SmartUploadContext';
import { AssetStatus } from 'src/types';
import { SmartUploadWizard } from './smartUpload/SmartUploadWizard';
import { SmartUploadPreview } from './smartUpload/SmartUploadPreview';

const MainContent = () => {
  const { mode, selectedResultIndex, wizardCollapsed, batchResults } = useSmartUpload();

  const allTransformsDone =
    mode === 'smart' &&
    batchResults.length > 0 &&
    batchResults.every(
      (r) => r.status === AssetStatus.COMPLETED || r.status === AssetStatus.FAILED,
    ) &&
    batchResults.some((r) => r.status === AssetStatus.COMPLETED);

  const showPreview = allTransformsDone;

  if (mode === 'smart') {
    return (
      <div
        className={`${styles.mainContent} ${styles.smartLayout} ${wizardCollapsed ? styles.smartCollapsed : ''}`}
      >
        <div className={styles.leftColumn}>
          <SmartUploadWizard />
          {selectedResultIndex !== null && <CampaignCreationSection />}
        </div>
        {showPreview && (
          <div className={styles.rightColumn}>
            <SmartUploadPreview />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.mainContent}>
      <div className={styles.leftColumn}>
        <InputSection />
        <CampaignCreationSection />
      </div>
      <PreviewSection />
    </div>
  );
};

const CampaignAutomationPage = () => {
  const selectionState = useSelectionState();

  return (
    <div className={styles.provider}>
      <ClientContextProvider>
        <SmartUploadProvider>
          <SelectionContext.Provider value={selectionState}>
            <AssetContextProvider>
              <main className={styles.page}>
                <Header />
                <SelectSection />
                <CampaignMetadataContextProvider>
                  <MainContent />
                </CampaignMetadataContextProvider>
                <Footer />
              </main>
            </AssetContextProvider>
          </SelectionContext.Provider>
        </SmartUploadProvider>
      </ClientContextProvider>
    </div>
  );
};

export { CampaignAutomationPage };
